declare namespace $ {

	type $mol_button_minor__title_bog_vmap_app_publish_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_publish_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_publish['publish_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_publish_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_publish['enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_bog_vmap_app_publish_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_publish['publish'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_copy__hint_bog_vmap_app_publish_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['hint'] >
	>
	type $mol_button_copy__text_bog_vmap_app_publish_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_publish['lib_link'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_button_copy__title_bog_vmap_app_publish_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_publish['lib_link'] >
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_view__sub_bog_vmap_app_publish_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_vmap_app_publish extends $mol_view {
		content( ): readonly($mol_view)[]
		publish_hint( ): string
		enabled( ): boolean
		publish( next?: any ): any
		note( ): string
		store( ): $bog_vmap_app_publish_store
		part( ): string
		source( ): string
		js( ): string
		css( ): string
		doc( ): string
		classes( ): readonly(string)[]
		lib_link( ): string
		foreign( ): boolean
		sub( ): ReturnType< $bog_vmap_app_publish['content'] >
		Publish( ): $mol_button_minor
		Copy( ): $mol_button_copy
		Note( ): $mol_view
	}
	
}

//# sourceMappingURL=publish.view.tree.d.ts.map